import React, { useEffect, useState } from 'react';
import { endpoints } from 'api/endpoints';
import { getRequestData } from 'api/api';
import { AssociationForSoberLiving } from './components/associationForSoberLiving';
import { Beds } from './components/beds';
import { ClientAnalytics, ScholarshipsAnalytics } from 'components';
import { ROLE_TYPES } from 'api/constants';
import { useUser } from 'context/userContext';
import { useAuth } from 'context/authContext';

export const ManagerDashboard = () => {
  const [dashboardData, setDashboardData] = useState();
  const { partnerId } = useAuth();
  const { userDetails } = useUser();

  useEffect(() => {
    (async () => {
      const params = { partner_ids: partnerId };
      const { data } = await getRequestData(endpoints.getDashboard(params), ROLE_TYPES.slh_manager);
      setDashboardData(data);
    })();
  }, [partnerId]);

  return (
    dashboardData && (
      <div className="flex flex-col w-full gap-y-6">
        <div className="flex gap-x-6 ">
          <AssociationForSoberLiving />
          {userDetails?.partner_details && <Beds partner={userDetails.partner_details} />}
        </div>
        <ClientAnalytics clients={dashboardData.clients} seeAllUrl="/clients" />
        <ScholarshipsAnalytics scholarships={dashboardData.scolarships} detailsUrl="/finances" />
      </div>
    )
  );
};
